module.exports = __webpack_public_path__ + "static/media/за.f33a3ed8.mp3";